<h1 mat-dialog-title>{{ titleType }} Program</h1>

<div mat-dialog-content>
  <form [formGroup]="form">
    <div class="flex-row gap-16">
      <mat-form-field class="flex-1">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" placeholder="" />
        @if (form.get('name')?.hasError('required')) {
          <mat-error>Name is required.</mat-error>
        }
        @if (form.get('name')?.hasError('maxlength')) {
          <mat-error>Name cannot exceed 255 characters.</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="flex-1">
        <mat-label>Type</mat-label>
        <mat-select formControlName="type" placeholder="">
          @for (linkedType of linkedTypes; track linkedType) {
            <mat-option [value]="linkedType.value">{{ linkedType.name }}</mat-option>
          }
        </mat-select>
        @if (form.get('type')?.hasError('required')) {
          <mat-error>Type is required.</mat-error>
        }
      </mat-form-field>
    </div>

    <app-multi-labels formControlName="campaigns" name="campaigns" searchKey="title" [placeholder]="'Campaigns'"
      [labels]="filteredCampaigns" [availableLabelsQuery]="allCampaigns" [optionBadgeFn]="campaignBadgeFn"></app-multi-labels>
    @if (locationDiffWarning) {
      <div class="location-diff-warning">
        <mat-icon>warning</mat-icon>
        <span>These campaigns have different location filters. Users may see inconsistent program availability.</span>
      </div>
    }
    @if (maxArrayLengthError) {
      <div class="error-message">
        You cannot select more than 5 campaigns.
      </div>
    }
    @if (wrongSelectError) {
      <div class="error-message">
        You selected unsupported campaign values.
      </div>
    }
  </form>
</div>

<div mat-dialog-actions class="gap-8">
  <lib-button variant="stroked" mat-dialog-close>Cancel</lib-button>
  <lib-button variant="raised" [disabled]="!form.valid" (buttonClick)="onSave()">Save</lib-button>
</div>